export interface NodeData {
  id: string
  company: string
  system: string
  connections: number
  icon: string
}

export const HARDCODED_NODES: NodeData[] = [
  {
    id: 'gravitate-hub',
    company: 'Gravitate',
    system: 'Gravitate S&D',
    connections: 245,
    icon: 'ApartmentOutlined',
    status: 'active',
    connectionAvatars: [
      'JD',
      'SM',
      'KW',
      'TL',
      'https://i.pravatar.cc/150?img=1',
    ],
    health: 98,
    operatingAs: ['Wholesaler', 'Supplier'],
    lastUpdate: new Date(Date.now() - 5 * 60 * 1000), // 5 minutes ago
  },
  {
    id: 'caseys-retail',
    company: "Casey's General Store",
    system: 'PDI Enterprise',
    connections: 187,
    icon: 'ShopOutlined',
    status: 'active',
    connectionAvatars: ['CG', 'https://i.pravatar.cc/150?img=2', 'MR', 'AP'],
    health: 94,
    operatingAs: ['Retailer'],
    lastUpdate: new Date(Date.now() - 12 * 60 * 1000), // 12 minutes ago
  },
  {
    id: 'tte-logistics',
    company: 'TTE Logistics',
    system: 'TMW Suite',
    connections: 92,
    icon: 'CarOutlined',
    status: 'active',
    connectionAvatars: ['TT', 'LB', 'https://i.pravatar.cc/150?img=3'],
    health: 87,
    operatingAs: ['Carrier'],
    lastUpdate: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
  },
  {
    id: 'midwest-dist',
    company: 'Midwest Distribution',
    system: 'Veeder-Root TLS-450PLUS',
    connections: 156,
    icon: 'InboxOutlined',
    status: 'active',
    connectionAvatars: [
      'MD',
      'https://i.pravatar.cc/150?img=4',
      'RK',
      'JL',
      'https://i.pravatar.cc/150?img=5',
    ],
    health: 91,
    operatingAs: ['Wholesaler', 'Carrier'],
    lastUpdate: new Date(Date.now() - 30 * 60 * 1000), // 30 minutes ago
  },
  {
    id: 'prime-suppliers',
    company: 'Prime Suppliers Inc',
    system: 'OPIS PricePro',
    connections: 78,
    icon: 'GlobalOutlined',
    status: 'active',
    connectionAvatars: ['PS', 'BW', 'https://i.pravatar.cc/150?img=6'],
    health: 96,
    operatingAs: ['Supplier'],
    lastUpdate: new Date(Date.now() - 45 * 60 * 1000), // 45 minutes ago
  },
  {
    id: 'quick-serve',
    company: 'QuickServe Foods',
    system: 'Gravitate S&D',
    connections: 134,
    icon: 'CoffeeOutlined',
    status: 'warning',
    connectionAvatars: ['QS', 'https://i.pravatar.cc/150?img=7', 'NP', 'TC'],
    health: 72,
    operatingAs: ['Retailer', 'Customer'],
    lastUpdate: new Date(Date.now() - 3 * 60 * 60 * 1000), // 3 hours ago
  },
  {
    id: 'regional-carriers',
    company: 'Regional Carriers LLC',
    system: 'TMW Suite',
    connections: 203,
    icon: 'TruckOutlined',
    status: 'active',
    connectionAvatars: [
      'RC',
      'https://i.pravatar.cc/150?img=8',
      'DM',
      'FL',
      'https://i.pravatar.cc/150?img=9',
      'WK',
    ],
    health: 89,
    operatingAs: ['Carrier'],
    lastUpdate: new Date(Date.now() - 15 * 60 * 1000), // 15 minutes ago
  },
  {
    id: 'tech-solutions',
    company: 'Tech Solutions Co',
    system: 'PDI Enterprise',
    connections: 45,
    icon: 'CloudServerOutlined',
    status: 'inactive',
    connectionAvatars: ['TS', 'https://i.pravatar.cc/150?img=10'],
    health: 45,
    operatingAs: ['Customer'],
    lastUpdate: new Date(Date.now() - 24 * 60 * 60 * 1000), // 1 day ago
  },
]
